export default __webpack_public_path__ + "static/media/Group 1.71458dca.svg";